<template>
  <div class="style">加载中。。。。
      <van-overlay :show="show">
    </van-overlay>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Overlay } from 'vant';
import commonService from '@/static/commonService';

export default {
    data() {
        return {
        show: true,
        linkUrl:''
        }
    },
    created() {
    this.linkUrl = location.href.split('url=')[1].replace(/%2F/g,"/").replace(/i8%3D/g,"g==");
    // const bian = window.btoa(this.linkUrl) // 编码
    // console.log(this.linkUrl)
    
  },
  mounted(){
    window.location.href = window.atob(this.linkUrl) == '' ? '/' : window.atob(this.linkUrl).indexOf('home.tianan')==-1?window.atob(this.linkUrl):window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[0] == 'activityDetails'?'http://wechat.tianan.net/ActivitiesDetalis/'+window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[1]:window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[0] == 'exclusiveActivitiesdetails'?'http://wechat.tianan.net/ExclusiveDetalis/'+window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[1]:window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[0] == 'financePlatform'?'http://wechat.tianan.net/propertyDetiles/'+window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[2]:'http://wechat.tianan.net/business/equipmentInfo/'+window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[2].split('?serviceId=')[1]+'/'+window.atob(this.linkUrl).split('http://home.tianan.net/navigator/')[1].split('/')[2].split('?serviceId=')[0];
    // this.linkUrl = location.href.split('url=')[1];
    // const bian = window.btoa(this.linkUrl) // 编码
    // window.atob(this.linkUrl) // 解码
    // window.location.href = window.atob(this.linkUrl);
  },

}
</script>

<style lang="scss" scoped>
@import '~@scss';
.style {
  background-color: #fff;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/property/Zpop.vue